<template>
  <div id="main-wrapper">
    <left-sidebar />
    <div
      class="page-wrapper py-0 position-relative"
      :class="{'closed-sidebar': !isOpen}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import LeftSidebar from '@/components/LeftSidebar'
import {mapState} from 'vuex'
export default {
  name: 'Layout',
  components: {LeftSidebar},
  computed: {
    ...mapState({
      isOpen: state => state.leftSidebar.isOpen
    })
  }
}
</script>

<style scoped lang="scss">
.page-wrapper {
  &.closed-sidebar {
    margin-left: 70px !important;
  }
}
</style>
